import "../../../App.css";
import React, {useCallback, useEffect, useState} from "react";
import {Button, Form, Input, Layout, message, Result} from "antd";
import "antd/dist/reset.css";
import useAxios from "axios-hooks";
import {CheckoutSubmissionRequest} from "../../../types/CheckoutSubmissionRequest";
import {useOrderId} from "../../../hooks/UseOrderId";
import {PaymentType} from "../../../App";
import {CardTypeEnum} from "../../../types/CardTypeEnum";
import {CheckoutStatusResult} from "../../../types/CheckoutStatusResult";
import {ProviderTypeEnum} from "../../../types/ProviderTypeEnum";
import WrappedCard from "../../antd/WrappedCard";
import jazzcashLogo from "../../../assets/jazzcash-logo.png";
import "./PkJazzcashTestMode.css";

const {Content} = Layout;

const ignore = false;
const OverdueTime = 3 * 60 * 1000;
const PollingTime = 5 * 1000;

// NOTICE: GET目前是同步的，后面有可能会需要支援非同步，近来收银台后先转圈等到GET有结果
function PkJazzcashTestMode({getCheckoutInfoData}: PaymentType) {
    const id = useOrderId();

    const [{data: putData}, executePost] =
        useAxios<CheckoutSubmissionRequest>(
            {
                url: `/v2/checkout/${id}`,
                method: "POST"
            },
            {manual: true}
        );
    console.log("[POST] checkout.putData", putData);

    const [
        {
            data: getCheckoutResultData,
            loading: pollingLoading
        },
        pollingCheckoutResult
    ] = useAxios<CheckoutStatusResult>(`/v2/orders/${id}`);

    const [submitCheckout, setSubmitCheckout] = useState(getCheckoutInfoData?.checkoutStatus === "SUBMITTED");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [form] = Form.useForm();
    const [isFormValid, setIsFormValid] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [countDownText, setCountDownText] = useState("Ready countdown");
    const [neverCountDown, setNeverCountDown] = useState(true);

    const onFormFinish = (values: any) => {
        setSubmitCheckout(true);

        // NOTICE: 三分截止
        startOverdueCountDown();

        if (!ignore) {
            executePost({
                data: {
                    id: id,
                    providerType: ProviderTypeEnum.WALLET,
                    providerName: CardTypeEnum.JazzCash,
                    customerAccount: values.customerAccount,
                    customerIdCard: values.customerIdCard
                }
            })
                .then(() => {
                    setSubmitCheckout(true);
                })
                .catch((error) => {
                    messageApi.error("Failed:" + error?.response?.data?.title);
                })
                .finally(() => {
                });
        }
    };

    const onButtonClick = () => {
        setIsSubmitting(true);
        form.submit();
    };

    const checkFormValidity = () => {
        form.validateFields()
            .then(() => {
                setIsFormValid(true);
            })
            .catch(() => {
                setIsFormValid(false);
            });
    }

    const [isOverdueTime, setIsOverdueTime] = useState<boolean>(false);
    console.log("0.isOverdueTime", isOverdueTime);

    // NOTICE: 十秒輪詢 way1
    useEffect(() => {
        const stoppingStatuses: string[] = ["SUCCESS", "FAIL"]

        let pollingCountDown: NodeJS.Timeout;
        if (isOverdueTime) {
            console.log(
                "[Polling] Cause overdue time , so no need to process to poll"
            );
        } else if (!submitCheckout) {
            checkFormValidity();
            console.log("[Polling] no need to process to poll");
        } else {
            console.log("[Polling] pollingLoading", pollingLoading);
            if (getCheckoutResultData?.status === "PROCESSING") {
                console.log("[Polling] restart to polling");
                if (neverCountDown){
                    setNeverCountDown(false);
                    submitCountDown();
                }

                pollingCountDown = setTimeout(function () {
                    pollingCheckoutResult()
                        .then((data) => {
                            console.log("[Polling] end to polling.data", data);
                        })
                        .catch((error) => {
                            console.log("[Polling] restart to polling.error", error);
                        })
                        .finally(() => {
                        });
                }, PollingTime);
            } else if (typeof getCheckoutResultData !== "undefined" && stoppingStatuses.includes(getCheckoutResultData.status)) {
                console.log("[Polling] end to polling.data", getCheckoutResultData);
                messageApi.info("Result: " + getCheckoutResultData.status);
            }
        }
        return () => {
            if (pollingCountDown) clearTimeout(pollingCountDown);
        };
    }, [submitCheckout, pollingLoading, isOverdueTime, getCheckoutResultData]);

    // NOTICE: 三分截止
    let countDown: NodeJS.Timeout;
    const startOverdueCountDown = useCallback(() => {
        console.log("[CountDown] start to count down");
        countDown = setTimeout(function () {
            console.log("[CountDown] end to count down");
            setIsOverdueTime(true);
        }, OverdueTime);
    }, []);

    const clearOverdueCountDown = () => {
        clearTimeout(countDown);
    };
    useEffect(() => {
        return () => {
            clearOverdueCountDown();
        };
    });

    const submitCountDown = () => {
        let num = 120;
        setCountDownText(formatTime(num));
        let timer = setInterval(() => {
            num--;
            setCountDownText(formatTime(num));
            if (num === 0) {
                setCountDownText("Time's Up !!!");
                clearInterval(timer);
            }
        }, 1000);
    };

    const formatTime = (seconds: number) => {
        let minutes = Math.floor(seconds / 60);
        let remainingSeconds = seconds % 60;
        return `${padZero(minutes)}:${padZero(remainingSeconds)}`;
    };

    const padZero = (num: number) => {
        return num < 10 ? `0${num}` : `${num}`;
    };

    return (
        <>
            {contextHolder}

            {/*NOTICE: 訂單未完成*/}
            {getCheckoutInfoData?.checkoutStatus === "VISITED" &&
                !submitCheckout && (
                    <Content>
                        <WrappedCard cardProps={{className: "jzt-payment-container"}}>
                            <>
                                <div className="jzt-logo-container">
                                    <img src={jazzcashLogo} alt="Jazzcash" className="jzt-logo-content"/>
                                </div>

                                <div className="jzt-amount-container">
                                    <div className="jzt-amount-content">
                                        <div className="jzt-amount">
                                            {getCheckoutInfoData?.orderAmount}
                                        </div>

                                        <div className="jzt-amount-currency">
                                            Amount (PKR)
                                        </div>
                                    </div>
                                </div>
                            </>

                            <Form
                                form={form}
                                onFinish={onFormFinish}
                                onChange={checkFormValidity}
                            >
                                <>
                                    <div className="jzt-form-container">
                                        <div className="jzt-input-container">
                                            <div className="jzt-input-label">
                                                <span>Account number</span>
                                                <span>اكاؤنث نمبر</span>
                                            </div>
                                            <Form.Item
                                                name="customerAccount"
                                                rules={[{
                                                    required: true,
                                                    message: "account should be an integer starting with 3 and totaling ten digits."
                                                }]}
                                                initialValue={getCheckoutInfoData?.receiverAccount}
                                            >
                                                <Input className="jzt-input-field"/>
                                            </Form.Item>

                                            <div className="jzt-input-label">
                                                <span>CNIC</span>
                                                <span>شناختی کارڈ</span>
                                            </div>
                                            <Form.Item
                                                name="customerIdCard"
                                                rules={[{
                                                    required: true,
                                                    message: "CNIC should be real CNIC number and thirteen digital integer."
                                                }]}
                                                initialValue={getCheckoutInfoData?.receiverIdCard}
                                            >
                                                <Input className="jzt-input-field"/>
                                            </Form.Item>

                                            <Form.Item>
                                                <div className="jzt-submit-button-container">
                                                    <Button type="primary" className="jzt-submit-button"
                                                            onClick={onButtonClick} disabled={!isFormValid}>
                                                        {isSubmitting ? "Paying..." : "Pay Now"}
                                                    </Button>
                                                </div>
                                            </Form.Item>
                                            <Form.Item name="reserved1" style={{display: 'none'}}>
                                                <Input/>
                                            </Form.Item>

                                            <div className="jzt-transaction-fee">
                                                <span style={{float: "left"}}>Transaction Fee</span>
                                                <span style={{float: "right"}}>0.00</span>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            </Form>
                            <p className="jzt-footer-text">
                                After clicking "pay now", please open your wallet and enter your
                                password to
                                complete the payment.<br/><br/>
                                براہ کرم پے کا بٹن دبانے کے بعد اپنا والیٹ اکاؤنٹ کھولیں پاسورڈ کے
                                اندراج سے رقم کی ادائیگی مکمل
                                کریں
                            </p>
                        </WrappedCard>
                    </Content>
                )}

            {/*NOTICE: 使用者填寫完畢送出，會看到等待付款中狀態頁面。*/}
            {submitCheckout &&
                !isOverdueTime &&
                getCheckoutResultData?.status === "PROCESSING" && (
                    <Result
                        status="info"
                        title={
                            <>
                                <div style={{textAlign: "center", color: "red"}}>
                                    Time Remaining<br/>
                                    {countDownText}
                                </div>
                                <div>
                                    Please open your wallet and approve the transaction now.<br/>
                                    مہربانی فرما کر اپنا والٹ اکاؤنٹ کھولیں اور رقم کی ادائیگی کریں
                                </div>
                            </>
                        }
                    />
                )}

            {/*NOTICE: 系統超過三分鐘後，使用者會看到訂單有問題之類訊息(後端之後會動態調整文案)。*/}
            {submitCheckout &&
                isOverdueTime &&
                getCheckoutResultData?.status === "PROCESSING" && (
                    <Result
                        status="warning"
                        title="We have not received your payment yet. If the transaction is delayed, please reach out to customer service if there is no further progress within two hours."
                    />
                )}
        </>
    );
}

export default PkJazzcashTestMode;
